// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"projectheader-module--headerContainer--1BGft","headerContent":"projectheader-module--headerContent--257VC"};